export const FirebaseConfig = {
	"projectId": "zoomerrrapp1",
	"appId": "1:787701765851:web:af065f0d1ed29422379efe",
	"databaseURL": "https://zoomerrrapp1-default-rtdb.firebaseio.com",
	"storageBucket": "zoomerrrapp1.firebasestorage.app",
	"apiKey": "AIzaSyCRcg4eVXiqxtR5QBK12EVBrkWhfPVqPAg",
	"authDomain": "zoomerrrapp1.firebaseapp.com",
	"messagingSenderId": "787701765851",
	"measurementId": "G-J50W8WK8VB",
	"projectNumber": "787701765851",
	"version": "2"
};